import { AnyFieldMeta } from '@tanstack/react-form';
import { ZodError } from 'zod';
import Message from '@app/component/message/Message';
import _isEmpty from 'lodash/isEmpty';
import Utilities from '@util/Utilities';

type FieldMessagesProps = {
	meta: AnyFieldMeta;
};

export const FieldMessages = ({ meta }: FieldMessagesProps, state: 'primary' | 'info' | 'success' | 'error' | 'warning' = 'error') => {
	if (!meta || !meta.isTouched) return null;

	return !_isEmpty(meta.errors) ? <Message state={state}>
		<div className="w-full">
			{meta.errors.map(({ message }: ZodError, index) => <div key={index} className={Utilities.classNames("w-full", index > 0 ? "mt-2" : "")}>{message}</div>)}
		</div>
	</Message> : <span />;
};